import { Reveal } from '@/components/Reveal';
import { Section } from '@/components/Section';
import { Tag } from '@/components/Tag';
import { capabilities, principles } from '@/content/site';
import styles from './Capabilities.module.css';

export function Capabilities() {
  return (
    <Section
      id="capabilities"
      tone="raised"
      eyebrow="capabilities"
      title="Deliberately boring technology, deliberately careful choices"
      lead="We pick tools our clients can hire for and we can defend in a review. The interesting part of your product should be the product."
    >
      <div className={styles.grid}>
        {capabilities.map((group, index) => (
          <Reveal key={group.title} className={styles.group} delay={index * 70}>
            <h3 className={styles.groupTitle}>{group.title}</h3>
            <div className={styles.items}>
              {group.items.map((item) => (
                <Tag key={item}>{item}</Tag>
              ))}
            </div>
          </Reveal>
        ))}
      </div>

      <div className={styles.principles}>
        {principles.map((principle, index) => (
          <Reveal key={principle.title} className={styles.principle} delay={index * 80}>
            <h3 className={styles.principleTitle}>{principle.title}</h3>
            <p className={styles.principleText}>{principle.text}</p>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
